import clsx from 'clsx'

import mainStyles from 'assets/css/main.module.scss'
import arrowIcon from 'assets/icons/arrow.svg'

interface Props {
  question: string
  answer: string
  icon: string
  alt: string
  isOpen: boolean
  onToggle: () => void
  isLast?: boolean
}

export default function QuestionItem({ question, answer, icon, alt, isOpen, onToggle, isLast = false }: Props) {
  return (
    <div className={clsx('w-full flex flex-col', !isLast && 'pb-4 border-b border-[#e7eaee]')}>
      {/* Header */}
      <button
        type="button"
        onClick={onToggle}
        className="w-full gap-6 flex flex-row items-center justify-between hover:cursor-pointer"
      >
        <img width={50} height={50} src={icon} alt={alt} />

        <span className={clsx(mainStyles.blackXLHeading, 'flex-1 text-left')}>{question}</span>

        <img
          src={arrowIcon}
          alt="arrow"
          className={clsx('transition-transform duration-300', isOpen && 'rotate-180')}
        />
      </button>

      <div
        className={clsx(
          'overflow-hidden transition-all duration-300 ease-in-out pr-10',
          isOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0',
        )}
      >
        <div className="ml-[74px] text-gray-600 text-lg pb-2">{answer}</div>
      </div>
    </div>
  )
}
